import React, { Component, Fragment } from "react";

import ProductBody from "pages/_components/ProductBody";
import ProductHead from "pages/_components/ProductHead";
import CustomProductHead from "pages/_components/CustomProductHead";

class ProductDetail extends Component {
    static Head = ProductHead;

    static CustomHead = CustomProductHead;

    static Body = ProductBody;

    render() {
        // eslint-disable-next-line react/prop-types
        const { children } = this.props;

        return <Fragment>{children}</Fragment>;
    }
}

export default ProductDetail;
